module.exports = __webpack_public_path__ + "epdf-app/principal/container/container-platform-popup-6m5_VxGU.html";